import * as moment from 'moment';
import { SoledadUtils } from '../../lib/helpers/utils';

export interface Message {
    // Props
    type: string;
    id: number;
    message: string;
    read: boolean;
    date: string;
    icon: number;
    title: string;
}

export interface MessageInfo {
    messages: Message[];
    messagesNews: Message[];
    unread: Message[];
}

/**
 * Message
 *
 * @export
 * @class Message
 */
export class MessageHelper {
    static create(): Message {
        return {
            type: '',
            id: 0,
            message: '',
            read: false,
            date: '',
            icon: 0,
            title: '',
        };
    }

    /**
     * Message creation from Api result
     *
     * @static
     * @param {Object} apiData
     * @returns
     */
    static transformFromApi(apiData: Object): Message {
        const object = MessageHelper.create();
        object.type = apiData['ME_TIPO'];
        object.id = apiData['ME_ID'];
        object.message = apiData['ME_MENSAJE'];
        object.read = apiData['ME_LEIDO'];
        object.icon = apiData['ME_ICONO'];
        object.title = apiData['ME_TITULO'];
        // object.read = false;

        const date = SoledadUtils.dateTimeParse(apiData['ME_FECHA']);
        object.date = moment(date).format('DD/MM/YYYY').toString();

        return object;
    }

    static mock() {
        return {
            result: 0,
            value: [
                {
                    ME_ID: 22653,
                    ME_TIPO: 'OBLIGADA_LECTURA',
                    ME_MENSAJE:
                        '\u003cp\u003eEstimados clientes,\u0026nbsp;\u003c/p\u003e \u003cp\u003eLes informamos que ya est\u0026aacute; disponible en el \u003cstrong\u003eapartado de facturas de tu B2B, el modelo 347\u003c/strong\u003e para todos aquellos clientes que hayan realizado compras de m\u0026aacute;s de 3.005,06\u0026euro; durante el a\u0026ntilde;o 2023.\u003c/p\u003e \u003cp\u003ePara cualquier \u003cstrong\u003econsulta\u003c/strong\u003e al respecto, les ofrecemos un correo electr\u0026oacute;nico donde podr\u0026aacute;n enviar todas sus dudas: \u003cspan style="text-decoration: underline;"\u003e347.soledad@gruposoledad.net\u003c/span\u003e\u003c/p\u003e',
                    ME_LEIDO: false,
                    ME_FECHA: '/Date(1707692400000)/',
                    ME_ICONO: 0,
                    ME_TITULO: '',
                },
                {
                    ME_ID: 22654,
                    ME_TIPO: 'OBLIGADA_LECTURA',
                    ME_MENSAJE:
                        '\u003cp\u003eEstimados clientes 2,\u0026nbsp;\u003c/p\u003e \u003cp\u003eLes informamos que ya est\u0026aacute; disponible en el \u003cstrong\u003eapartado de facturas de tu B2B, el modelo 347\u003c/strong\u003e para todos aquellos clientes que hayan realizado compras de m\u0026aacute;s de 3.005,06\u0026euro; durante el a\u0026ntilde;o 2023.\u003c/p\u003e \u003cp\u003ePara cualquier \u003cstrong\u003econsulta\u003c/strong\u003e al respecto, les ofrecemos un correo electr\u0026oacute;nico donde podr\u0026aacute;n enviar todas sus dudas: \u003cspan style="text-decoration: underline;"\u003e347.soledad@gruposoledad.net\u003c/span\u003e\u003c/p\u003e',
                    ME_LEIDO: false,
                    ME_FECHA: '/Date(1707692400000)/',
                    ME_ICONO: 0,
                    ME_TITULO: '',
                },
                {
                    ME_ID: 22655,
                    ME_TIPO: 'ULTIMAS_NOTICIAS',
                    ME_MENSAJE:
                        '\u003cp\u003eNoticia,\u0026nbsp;\u003c/p\u003e \u003cp\u003eLes informamos que ya est\u0026aacute; disponible en el \u003cstrong\u003eapartado de facturas de tu B2B, el modelo 347\u003c/strong\u003e para todos aquellos clientes que hayan realizado compras de m\u0026aacute;s de 3.005,06\u0026euro; durante el a\u0026ntilde;o 2023.\u003c/p\u003e \u003cp\u003ePara cualquier \u003cstrong\u003econsulta\u003c/strong\u003e al respecto, les ofrecemos un correo electr\u0026oacute;nico donde podr\u0026aacute;n enviar todas sus dudas: \u003cspan style="text-decoration: underline;"\u003e347.soledad@gruposoledad.net\u003c/span\u003e\u003c/p\u003e',
                    ME_LEIDO: false,
                    ME_FECHA: '/Date(1707692400000)/',
                    ME_ICONO: 0,
                    ME_TITULO: 'Titulo',
                },
                {
                    ME_ID: 22656,
                    ME_TIPO: 'ULTIMAS_NOTICIAS',
                    ME_MENSAJE:
                        '\u003cp\u003eNoticia 2,\u0026nbsp;\u003c/p\u003e \u003cp\u003eLes informamos que ya est\u0026aacute; disponible en el \u003cstrong\u003eapartado de facturas de tu B2B, el modelo 347\u003c/strong\u003e para todos aquellos clientes que hayan realizado compras de m\u0026aacute;s de 3.005,06\u0026euro; durante el a\u0026ntilde;o 2023.\u003c/p\u003e \u003cp\u003ePara cualquier \u003cstrong\u003econsulta\u003c/strong\u003e al respecto, les ofrecemos un correo electr\u0026oacute;nico donde podr\u0026aacute;n enviar todas sus dudas: \u003cspan style="text-decoration: underline;"\u003e347.soledad@gruposoledad.net\u003c/span\u003e\u003c/p\u003e',
                    ME_LEIDO: true,
                    ME_FECHA: '/Date(1707692400000)/',
                    ME_ICONO: 0,
                    ME_TITULO: 'Titulo',
                },
                {
                    ME_ID: 22657,
                    ME_TIPO: 'ALERTA',
                    ME_MENSAJE:
                        '\u003cp\u003eNoticia 2,\u0026nbsp;\u003c/p\u003e \u003cp\u003eLes informamos que ya est\u0026aacute; disponible en el \u003cstrong\u003eapartado de facturas de tu B2B, el modelo 347\u003c/strong\u003e para todos aquellos clientes que hayan realizado compras de m\u0026aacute;s de 3.005,06\u0026euro; durante el a\u0026ntilde;o 2023.\u003c/p\u003e \u003cp\u003ePara cualquier \u003cstrong\u003econsulta\u003c/strong\u003e al respecto, les ofrecemos un correo electr\u0026oacute;nico donde podr\u0026aacute;n enviar todas sus dudas: \u003cspan style="text-decoration: underline;"\u003e347.soledad@gruposoledad.net\u003c/span\u003e\u003c/p\u003e',
                    ME_LEIDO: true,
                    ME_FECHA: '/Date(1707692400000)/',
                    ME_ICONO: 0,
                    ME_TITULO: '',
                },
            ],
        };
    }
}

/**
 * Message
 *
 * @export
 * @class Message
 */
export class MessageInfoHelper {
    static create(): MessageInfo {
        return {
            messages: [],
            messagesNews: [],
            unread: [],
        };
    }
}
